import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitTimerTask extends Task {
    constructor(assetLibrary, timerConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const timerJson = assetLibrary.getAsset("timer-config");
            timerConfig.setPropertiesFromObject(timerJson);

            callback(this);
        }
    }
}